import { Classification, GenericObject, copyFields } from '@synergy/models';

import { Account } from './account';
import { Customer } from './customer';
import { PaymentTerm } from './payment-term';

export class Supplier extends Account {
    public isChargingSupplier!: boolean;
    public whitelistedCustomers!: Customer[];
    public classifications!: Classification[];
    public requireFunctionalAssets?: boolean;
    /** What the supplier grants POOLALPIN; carried beside an invoice (#2326 R-241). */
    public poolPaymentTerm?: PaymentTerm;

    public static fromPlainObject(object: GenericObject): Supplier {
        const supplier = new Supplier();

        // Import own keys
        copyFields(object, supplier);

        // Import from base class (Account)
        const account = Account.fromPlainObject(object);

        // Overwrite own keys with base keys
        copyFields(account, supplier);

        if (object['whitelistedCustomers']) {
            supplier.whitelistedCustomers = object['whitelistedCustomers'].map(Customer.fromPlainObject);
        }

        return supplier;
    }
}
